import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['entityFilterInput', 'entityFilter', 'hideUnassignedInput']

  resetEntityFilter() {
    if (this.hasHideUnassignedInputTarget) {
      this.hideElement(this.hideUnassignedInputTarget)
    }
    if (this.hasEntityFilterTarget) {
      this.hideElement(this.entityFilterTarget)
    }

    this.entityFilterInputTargets.forEach(input => {
      input.checked = false
    })
  }

  changeVisibilityHideUnassignedInput(event) {
    if (!this.hasHideUnassignedInputTarget) return

    const selectedReportIndicatorId = event.currentTarget.value
    if (selectedReportIndicatorId !== '') {
      this.hideElement(this.hideUnassignedInputTarget)
    } else {
      this.displayElement(this.hideUnassignedInputTarget)
    }
  }

  hideElement(element) {
    element.classList.add('hidden')
  }

  displayElement(element) {
    element.classList.remove('hidden')
  }
}
